// Entry point for the build script in your package.json
import "./site_version"
import "@hotwired/turbo-rails"
import "./controllers"
import "@popperjs/core"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap


